import { useConfig } from '@occc/config';

import RetailerNetworkLocationUpdatePage from './retailer-network-location-update-page';
import RetailerNetworkMyStoresStoreV2UpdatePage from './retailer-network-my-stores-store-v2-update-page';

export const RetailerNetworkLocationUpdateVersionSwitch = () => {
  const { config } = useConfig();

  return config.retailerConnectRedesignV2.enabled ? (
    <RetailerNetworkMyStoresStoreV2UpdatePage />
  ) : (
    <RetailerNetworkLocationUpdatePage />
  );
};
